var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_7056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5998 8.34603H21C22.1046 8.34603 23 9.24146 23 10.346V12.4504C23 12.7116 22.9488 12.9703 22.8494 13.2119L19.755 20.7268C19.6007 21.1015 19.2355 21.346 18.8303 21.346H2C1.44772 21.346 1 20.8983 1 20.346V10.346C1 9.79374 1.44772 9.34603 2 9.34603H5.48184C5.80677 9.34603 6.11143 9.18816 6.29881 8.92271L11.7522 1.19706C11.8947 0.995189 12.1633 0.927681 12.3843 1.03819L14.1984 1.94521C15.25 2.47104 15.7931 3.65862 15.5031 4.79805L14.5998 8.34603ZM7 10.9335V19.346H18.1606L21 12.4504V10.346H14.5998C13.2951 10.346 12.3398 9.11698 12.6616 7.85261L13.5649 4.30464C13.6229 4.07675 13.5143 3.83923 13.3039 3.73407L12.6428 3.4035L7.93275 10.0761C7.68285 10.4301 7.36341 10.7203 7 10.9335ZM5 11.346H3V19.346H5V11.346Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_7056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.345703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.6cccb385a9709f213bb46f2cce93b9ce.svg";
export { ForwardRef as ReactComponent };